export default __webpack_public_path__ + "static/media/Q_Matting.61080e1f.jpg";